/**
 * @generated SignedSource<<be02efdb65026a8bad794dace53cd7a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Header_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderWithComplexMenuDesktop_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderWithComplexMenuMobile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderWithSimpleMenu_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": "__isViewer"
};

node.hash = "341cee5ee9444c39cbbeb4e0e9c2702b";

module.exports = node;
